import _kebabCase from 'lodash/kebabCase';

class NavbarController {
  constructor($state, $scope) {
    'ngInject';
    $scope.$state = $state;
    this.$state = $state;
    this.navigationLabels = {
      news: 'News',
      'news.item': 'News',
      events: 'Eventi',
      'events.event': 'Eventi',
      apps: 'APPs',
      offices: 'Sedi Territoriali',
      'offices.office': 'Sedi Territoriali',
      settings: 'Impostazioni',
      'apps.digitalAgenda': 'Agenda Digitale',
      'apps.digitalAgenda.show': 'Agenda Digitale',
      'apps.projectManager': 'Progetto Manager',
      'apps.projectManager.list': 'Progetto Manager',
      'apps.projectManager.list.show': 'Progetto Manager',
      'apps.youtube': 'Youtube',
      'apps.youtube.show': 'Youtube',
    }
  }

  goToParentState() {
    let nextState = (this.$state.$current.parent && !this.$state.$current.parent.abstract) ?
      this.$state.$current.parent.name : 'home';
    console.debug('Current State', this.$state.current.name, 'going to', nextState);
    this.$state.go(nextState);
  }

  showMobileNavbar() {
    return this.$state.current.name != 'home';
  }

  screenName() {
    return this.navigationLabels[this.$state.current.name] || this.$state.current.name;
  }

  screenNameClass() {
    return _kebabCase(this.screenName());
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js